import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'talent-video-results',
    templateUrl: 'talent-video-results.component.html',
    styleUrls: ['talent-video-results.component.scss']
})
export class TalentVideoResultsComponent {
    @Input() results = [];
    @Input() checkboxesEnabled = true;

    @Output() onHandleOpen = new EventEmitter();

    constructor() {
    }

    handleTableRowClick(result) {
        result.collapsed = !result.collapsed;
    }

    handleOpen(result) {
        const item: any = {
            parrot_id: result.parrot_id,
            title: result.title,
            displayName: result.displayName,
            catalogState: result.catalog_state,
            primary_occupation: result.primary_occupation ? result.primary_occupation : undefined,
            birth_date: result.birth_date ? result.birth_date : undefined,
            birth_year: result.birth_year ? result.birth_year : undefined,
            imdb_id: result.imdb_id,
            contentType: result.contentType
        };
        this.onHandleOpen.emit(item);
    }

    formatCatalogState(catalogState) {
        return catalogState.split('_').map((item) => {
            return item[0].toUpperCase().concat(item.slice(1));
        }).join(' ');
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/talent-video-results/talent-video-results.component.ts